import React from "react"
import { Money } from "./images/Money"
import { Shopping } from "./images/Shopping"

export const variantConfig = {
  download: [
    {
      title: (
        <>
          Рефинансируйте <br className="d-ld-none" /> кредитные карты
        </>
      ),
      description: (
        <>
          Получите до 300 000 ₽ на&nbsp;рефинансирование&nbsp;задолженности по&nbsp;кредитным картам
          любых банков в&nbsp;рассрочку* на&nbsp;24&nbsp;месяца
        </>
      ),
      Icon: Money,
      alt: "деньги",
      buttonText: "Оформить",
      secondary: true,
    },
    {
      title: "Покупайте там, где удобно",
      description: <>Более 260 000 магазинов-партнеров на&nbsp;любой вкус и&nbsp;бюджет</>,
      Icon: Shopping,
      alt: "покупки",
      buttonText: "Оформить",
    },
  ],
}
